export class ConfirmationModel {
  public Name : string;
  public Purpose: Purpose;
  public ActionTaken: ActionTaken;
  public ActionContent: string;
  public Message: string;
  public Url: string;
  public UpdatedBy: string;
  public IsDeleted: boolean = false;

  public FormId: string;
  public Id: number;
}

export enum Purpose {
  OnSuccess = 1,
  OnFailure = 2
}

export enum ActionTaken {
  ShowAMessage = 1,
  RedirectToPage = 2
}

